<template>
  <div>
    <!-- <vuex-breadcrumb></vuex-breadcrumb> -->
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <product-model-show :id="id" @gotAttrs="assignAttrs"></product-model-show>
        </b-col>
        <b-col md="8">
          <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Product Listing" active>
              <product-listing-index
                :filtering="filtering"
                :ams_template="ams_template"
              ></product-listing-index>
            </b-tab>
            <b-tab title="Interest">
              <!-- <polymorphic-reference-index
                :filtering="filtering_reference"
                :ams_template="ams_template_reference"
              ></polymorphic-reference-index> -->
              <integer-reference-information-card-index
                :reference_type='reference_type'
                :filtering="filtering_reference"
                :reference_id="interest_id"
                :api_path="api_path"
              ></integer-reference-information-card-index>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
// import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProductModelShow from './ProductModelShow.vue'
import ProductListingIndex from './ProductListingIndex.vue'
// import PolymorphicReferenceIndex from './PolymorphicReferenceIndex.vue'
import IntegerReferenceInformationCardIndex from './IntegerReferenceInformationCardIndex.vue'

export default {
  components: {
    // VuexBreadcrumb,
    ProductModelShow,
    ProductListingIndex,
    // PolymorphicReferenceIndex,
    IntegerReferenceInformationCardIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      interest_id: undefined,
      reference_type: 'Interest',
      filtering: {
        product_model_ids: this.id
      },
      ams_template: {
        type: 'product-listings',
        description: undefined,
        attributes: {
          'product-model-id': this.id,
          'price-cents': 0
        }
      },
      filtering_reference: {
        reference_to_type: 'ProductModel',
        reference_to_id: this.id
      },
      // interest_filtering: {
      //   reference_to_type: 'Interest',
      //   reference_to_id: undefined
      // },
      // ams_interest_info_template: {
      //   type: 'poly-integer-references',
      //   description: undefined,
      //   attributes: {
      //     reference_to_type: 'Interest',
      //     reference_to_id: undefined
      //   }
      // },
      ams_template_reference: {
        type: 'polymorphic-references',
        descrition: undefined,
        attributes: {
          'reference-to-type': "ProductModel",
          'reference-to-id': this.id
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.interest_id = this.attrs['interest-id']
      // this.interest_filtering.reference_to_id = this.attrs['interest-id']
      // this.ams_interest_info_template.attributes['reference_to_id'] = this.attrs['interest-id']
      this.ams_template.description = description + ' ' + this.attrs['name']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>